// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Helpers
import autosize from 'autosize';
// Styles
import './OMTextArea.scss';

class OMTextArea extends Component {
  componentDidMount() {
    if (!this.props.isInput) {
      autosize(document.querySelector(`#${this.props.id}`));
      if (this.props.initialValue) {
        this.addValue(this.props.initialValue);
      }
    }
  }

  componentWillReceiveProps({ initialValue }) {
    if (!this.props.isInput && initialValue && (initialValue !== this.props.initialValue)) {
      this.addValue(initialValue);
    }
  }

  setInputRef = (textarea) => {
    this.textarea = textarea;
    if (this.props.textAreaRef) {
      this.props.textAreaRef(textarea);
    }
  }

  addValue = (value) => { this.textarea.value = value; };

  render() {
    const { initialValue, isInvalid, isInput, maxLength, ...restProps } = this.props;
    const InputTeg = isInput ? 'input' : 'textarea';

    return (
      <InputTeg
        maxLength={maxLength}
        ref={this.setInputRef}
        id={this.props.id}
        className={cx('form-control', { not_valid: isInvalid })}
        placeholder={this.props.placeholder}
        {...restProps}
      />
    );
  }
}

OMTextArea.propTypes = {
  placeholder: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  id: PropTypes.string,
  isInput: PropTypes.bool,
  isInvalid: PropTypes.bool,
  maxLength: PropTypes.number,
  initialValue: PropTypes.string,
  textAreaRef: PropTypes.func
};

export default OMTextArea;
